import { createContext, useContext } from 'react';

export interface ThemeContextValue {
  theme: 'dark';
  toggleTheme: () => void;
  isDark: true;
}

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'dark',
  toggleTheme: () => {},
  isDark: true,
});

export function useTheme() {
  return useContext(ThemeContext);
}
